/**************************************************************************************************/
/*   File: /src/app/stores/states/download/state.ts                                               */
/*   Project: newplan-frontend                                                                    */
/*   Created Date: Tuesday February 19th 2019                                                     */
/*   Author: Andrea Zamboni andrea.zamboni@trilogis.it                                            */
/*   -----                                                                                        */
/*   Last Modified: Wed Apr 17 2019                                                               */
/*   Modified By: Andrea Zamboni                                                                  */
/*   -----                                                                                        */
/*   Copyright (c) 2019 Trilogis s.r.l. for SIAG                                                  */
/**************************************************************************************************/
import * as fromShared from '../../../shared';

/**
 * The download state
 */
export interface DownloadState {
  /**
   * The features
   */
  features: Array<any>;
  /**
   * The ambiti array
   */
  ambiti: fromShared.models.Ambito[];
  /**
   * Is prepared
   */
  isPreparingSpatial: boolean;
  /**
   * The messages
   */
  messages: fromShared.models.Message[];
  /**
   * Is prepared
   */
  isReady: boolean;
  /**
   * The taskId
   */
  taskId: number;
  /**
   * The is loading 
   */
  isLoading: boolean;
  /**
   * The dossier content
   */
  dossierContent: fromShared.models.DossierContent;
  /**
   * The is preparing public
   */
  isPreparingPublic: boolean;
  /**
   * This is preparing regulations
   */
  isPreparingRegulations: boolean;
  /**
   * The pbulic documents array
   */
  publicDocuments: fromShared.models.PublicDocument[];
  /**
   * The regulations array
   */
  regulationsResponse: fromShared.models.RegulationResponse[];
}

/**
 * The initial download state
 */
export const INITIAL_DOWNLOAD_STATE: DownloadState = {
  features: [],
  ambiti: [],
  isPreparingSpatial: false,
  messages: [],
  isReady: false,
  taskId: undefined,
  isLoading: false,
  dossierContent: undefined,
  isPreparingPublic: false,
  isPreparingRegulations: false,
  publicDocuments: [],
  regulationsResponse: []
};


/**
 * The state name
 */
export const STATE_NAME = 'download';